import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL_OSINT;
const API_URL_BACKEND = process.env.VUE_APP_BASE_API_URL;
// const ELASTIC_API = process.env.VUE_APP_ELASTIC_API;

class PhoneService {
    search(data) {
        return axios.post(API_URL+'phonenumber', data);
    }
    
    info(data) {
        return axios.post(API_URL+'phonenumber', data);
    }
    
    tags(data) {
        return axios.post(API_URL+'getcontact/tagslist', data);
    }
    
    add_contact(data) {
        return axios.post(API_URL_BACKEND+'get-contact', data, { headers: authHeader() });
    }

    detail_contact(id) {
        return axios.get(API_URL_BACKEND+'get-contact/'+id, { headers: authHeader() });
    }

    searchPhoneTokped(ip, data) {
        return axios.post(ip+'tokopedia/_search', data, { headers: {'Content-Type': 'application/json'} });
    }

    searchPhoneFb(ip, data) {
        return axios.post(ip+'facebook/_search', data, { headers: {'Content-Type': 'application/json'} });
    }
}

export default new PhoneService();
